<template>
    <div class="unifonic-credentials-form">
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="Profile Name" label="WhatsApp Profile Name" :required="true" :numeric="false"
            v-model="model.name" :rules="[nameRule]" />
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="Telephone Number" label="WhatsApp Telephone Number" :required="true" :numeric="false"
            v-model="model.phone" :rules="[phoneRule]" />
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="Application ID" label="Application ID" :required="true" :numeric="false"
            v-model="model.applicationId" :rules="[nonEmptyRule]" />
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="Public ID" label="Public ID" :required="true" :numeric="false"
            v-model="model.publicId" :rules="[nonEmptyRule]" />
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="API Secret" label="API Secret" :required="true" :numeric="false"
            v-model="model.apiSecret" :rules="[secretRule]" />
        <text-input class="unifonic-credentials-form__text-input" type="text"
            placeholder="Webhook Secret" label="Webhook Secret" :required="true" :numeric="false"
            v-model="model.webhookSecret" :rules="[secretRule]" />
    </div>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";

const SECRET_RE = /^[A-Za-z0-9]{16,}$/;
const PHONE_RE = /^\+?[0-9]+$/;

export default {
    name: "UnifonicCredentialsForm",
    components: { TextInput },

    props: {
        value: {
            type: Object,
            required: true
        },
        existingHandleIds: {
            type: Array,
            default: () => []
        },
        existingNamesAndHandles: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            model: { ...this.value }
        }
    },

    computed: {
        allValid() {
            return !!this.model.name?.trim()
                && !this.existingNamesAndHandles.includes(this.model.name)
                && PHONE_RE.test(this.model.phone || "")
                && !this.existingHandleIds.includes(this.model.phone)
                && !!this.model.applicationId?.trim()
                && !!this.model.publicId?.trim()
                && SECRET_RE.test(this.model.apiSecret || "")
                && SECRET_RE.test(this.model.webhookSecret || "");
        }
    },

    watch: {
        model: {
            deep: true,
            handler(v) {
                this.$emit('input', { ...v });
            }
        },
        allValid: {
            immediate: true,
            handler(v) {
                this.$emit('valid', v);
            }
        }
    },

    methods: {
        nonEmptyRule(value) {
            return (value && value.trim().length > 0) ? true : "Required";
        },

        nameRule(value) {
            if (!value || !value.trim()) return "Required";
            if (this.existingNamesAndHandles.includes(value)) return "A WhatsApp profile with that name already exists on this account";
            return true;
        },

        phoneRule(value) {
            if (!value) return "Required";
            if (!PHONE_RE.test(value)) return "Digits only, optionally prefixed with '+'";
            if (this.existingHandleIds.includes(value)) return "A WhatsApp profile with that number already exists on this account";
            return true;
        },

        secretRule(value) {
            if (!value) return "Required";
            return SECRET_RE.test(value) ? true : "Must be at least 16 alphanumeric characters (A-Z, a-z, 0-9)";
        }
    }
}
</script>

<style scoped lang="sass">
.unifonic-credentials-form
    display: flex
    flex-direction: column
    row-gap: 5px

    &__text-input
        height: 75px

    ::v-deep input
        width: 80%
</style>
